import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {Grid, GridColumn as Column} from '@progress/kendo-react-grid';
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { orderBy } from '@progress/kendo-data-query';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import numbers from 'cldr-numbers-full/main/fr/numbers.json';
import currencies from 'cldr-numbers-full/main/fr/currencies.json';
import caGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/fr/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/fr/timeZoneNames.json';


import data from '../json/vineyards.json';

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
);

class cellWithBackGround extends React.Component {
    render() {
        const data = this.props.dataItem[this.props.field];

        const icon = data < 0 ? <span className="k-icon k-i-sort-desc-sm" />
            : data > 0 ? <span className="k-icon k-i-sort-asc-sm" />
            : <span />

        const GOLD = "rgba(255,215,0,0.80)";
        const GREEN = "rgba(55,180,0,0.50)";
        const BLUE = "rgba(0,179,170,0.50)";
        const RED = "rgba(243,23,0,0.50)";
        const WHITE = "rgba(255,255,255,0.32)";
        const style = {
            backgroundColor: data > 0.1 ? GOLD
                : data > 0.05 ? GREEN
                : data > 0.03 ? BLUE
                : data < 0 ? RED : WHITE
        };

        return (
            <td style={style}>
                {
                    this.props.dataItem[this.props.field] != null ?
                    Number(this.props.dataItem[this.props.field]).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:2})
                    : ""
                } {icon}
            </td>
        );
    }
}

export default class SummaryTable extends Component {
    state = {
        sort: [
            // { field: 'averagePrice2017', dir: 'desc' }
            { field: 'row', dir: 'asc' }
        ]
    }
    render() {
        return (
            <LocalizationProvider language="fr-FR">
                <IntlProvider locale="fr" >
                    <div>
                        <h2>Tableau récapitulatif</h2>
                        <Grid
                            style={{height: '800px'}}
                            data={orderBy(data, this.state.sort)}
                            sortable
                            sort={this.state.sort}
                            onSortChange={(e) => {
                                this.setState({
                                    sort: e.sort
                                });
                            }}
                        >
                            <Column field="basin" title="Bassin" />
                            <Column field="region" title="Région" />
                            <Column field="department" title="Département" />
                            <Column field="id" title="Appellation" cell={(props) => (
                                <td>
                                    <Link to={`/vineyards/${props.dataItem["id"]}`} >{props.dataItem["vineyard"]}</Link>
                                </td>
                            )}/>
                            <Column field="5years"  title="5 ans"  width="110px" cell={cellWithBackGround}/>
                            <Column field="7years"  title="7 ans"  width="110px" cell={cellWithBackGround}/>
                            <Column field="10years" title="10 ans" width="110px" cell={cellWithBackGround}/>
                            <Column field="20years" title="20 ans" width="110px" cell={cellWithBackGround}/>
                            <Column field="30years" title="30 ans" width="110px" cell={cellWithBackGround}/>
                            <Column field="lastAveragePrice" title="Prix moy. ha" format="{0:c0}"/>
                        </Grid>
                    </div>
                </IntlProvider>
            </LocalizationProvider>
        );
    };
}
